/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { RESOURCE_GROUPS } from '@/features/resources/resourceLinks';
import { ShellDialog } from './ShellDialog';

/** Resource links dialog; opens globally to avoid resetting tool state. */
export function ResourceLinksModal({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <ShellDialog
      onClose={onClose}
      icon="menu_book"
      title={t('resources.title')}
      description={t('resources.subtitle')}
      size="lg"
      className="res-modal"
    >
      <div className="res-modal-body">
        {RESOURCE_GROUPS.map((group) => (
          <section className="res-group" key={group.title} aria-label={t(group.title)}>
            <div className="res-group-head">
              <h3>{t(group.title)}</h3>
              <p>{t(group.description)}</p>
            </div>
            <div className="res-grid">
              {group.links.map((link) => (
                <a
                  className="res-card"
                  href={link.href}
                  key={link.label}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="res-card-ic">
                    <Icon name={link.icon} size={20} />
                  </span>
                  <span className="res-card-main">
                    <span className="res-card-title">{t(link.label)}</span>
                    <span className="res-card-desc">{t(link.description)}</span>
                  </span>
                  <Icon name="open_in_new" size={18} className="res-card-ext" />
                </a>
              ))}
            </div>
          </section>
        ))}
      </div>
    </ShellDialog>
  );
}
